<template>
    <div>
        <base-header class="pb-6 pb-8 pt-6 pt-md-6" type="gray-100">
          
        </base-header>

            <template v-if="loading">
                <div class="m-2">
                <skeleton altura="400px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>

        <div class="container-fluid mt--7" v-if="!loading">
            <div class="row">
                <div class="col-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Cadastro de Procedimento</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <div class="pl-lg-4">
                                    <div class="row">
                                       <div class="col-12 col-lg-8">
                                             
                                        
                                         <div class="form-group has-label"> 
                                             <label class="form-control-label"> 
                                                Protético Vinculado
                                             </label>

                                               <v-select 
                                                :options="proteticos" 
                                                label="nomeCompleto"
                                                class="form-control-alternative"
                                                v-model="model.protetico"
                                                >
                                                <template #option="option">
                                                   {{ option.nomeCompleto }}
                                                </template>
                                               </v-select>
                                          </div>
                                          </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-8">
                                            <base-input alternative=""
                                                label="Nome Procedimento"
                                                input-classes="form-control-alternative"
                                                v-model="model.nome"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4 col-12">
                                            <base-input alternative=""
                                                label="Valor do Procedimento"
                                                input-classes="form-control-alternative"
                                                v-model="model.valor"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <hr class="my-4" />

                                 <div class="pl-lg-4 text-right">

                                 <template v-if="loading2">
                                    <div class="m-2">
                                    <skeleton altura="100px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                    </div>
                                </template>

                                <div  v-if="!loading2">
                                 <base-button
                                    type="default"
                                    @click="salvar()"
                                    v-html="txt1"
                                    ></base-button>
                                </div>
                            </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import procedimentos from '@/cflow/procedimentoProtetico.js'
//import agenda from '@/cflow/agendaProtetica.js'
  //import parametros from "@/cflow/parametros.js";
  //import BaseButton from '../../components/BaseButton.vue';
  //import BaseInput from '../../components/BaseInput.vue';
  //import Multiselect from "vue-multiselect";
  import storage from 'storage';
  import vSelect from "vue-select";
    import router from '@/router'
import "vue-select/dist/vue-select.css";
  export default {
    name: 'tables',
    components: {
     // Multiselect,
      //BaseInput,
      vSelect
    },
    
    methods: {
        salvar: function() {

            this.loading2 = true;

            const _this = this;
        
        let form = this.model;
        const _id = this.$route.params.id || '';

        procedimentos.salvar(_id, form).then(() => {
                _this.loading = false;
                _this.hasSuccess = true;
                this.loading2 = false;
                 router.push('/procedimentos-proteticos');
                
            }).catch((error) => {
                console.err('ERROR', error)
                _this.loading = false;
                _this.hasError = true;
                 setTimeout(function(){
                    _this.hasError = false;
                },5000);
            });

           
        }
    },
    data() {
      return {
        txt1: 'Salvar',
        tipo: null,
        id: null,
        status: [{'nome': 'Aguardando', 'valor': 'aguardando'}, {'nome': 'Em Produção', 'valor': 'producao'}, {'nome': 'Finalizado', 'valor': 'finalizado'}],
        proteticos: [],
        hasSuccess: false,
        hasError: false,
        loading: false,
        loading2: false,
        dated: '',
        model: {
          protetico: '',
          laboratorio: '',
          nome: '',
          descritivo: '',
          valor: ''
        }
      }
    },

     mounted(){

      this.loading = true; 
      const _id = this.$route.params.id;
      const _this = this;
      var user = storage.get("user");

      procedimentos.buscarPorLab(user.id).then(res => {
        this.proteticos = res;

        if(_id) {
            procedimentos.detalhes(_id).then(res => {
                let model2 = {
                    protetico: res.protetico,
                    nome: res.nome,
                    descritivo: res.descritivo,
                    valor: res.valor.toLocaleString('pt-br', {minimumFractionDigits: 2})
                }

                _this.model = model2;
                this.loading = false;
               
            }).catch((error) => {
                console.err('ERROR', error)
            });
        } else {
            this.loading = false;
        }

    }).catch((error) => {
        console.err('ERROR', error);
    });

    }
  };
</script>
<style>
.height, .ProseMirror {
    min-height: 300px;
}
.select {
    width: 100%;
    padding: 5px 5px;
}
</style>
